import { useEffect, useState } from "react";

export const UseSettingColumns = (defaultColumns = 9) => {
    // Lógica de la función
    const [visibleCols, setVisibleCols] = useState(defaultColumns);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width > 1600) setVisibleCols(defaultColumns);
            else if (width > 1425) setVisibleCols(defaultColumns - 1 > 0 ? defaultColumns - 1 : 1);
            else if (width > 1350) setVisibleCols(defaultColumns - 2 > 0 ? defaultColumns - 2 : 1);
            else if (width > 1175) setVisibleCols(defaultColumns - 3 > 0 ? defaultColumns - 3 : 1);
            else if (width > 1080) setVisibleCols(defaultColumns - 4 > 0 ? defaultColumns - 4 : 1);
            // else if (width > 800) setVisibleCols(5);
            // else if (width > 700) setVisibleCols(4);
            else if (width > 970) setVisibleCols(defaultColumns - 5 > 0 ? defaultColumns - 5 : 1);
            else if (width > 600) setVisibleCols(defaultColumns - 6 > 0 ? defaultColumns - 6 : 1);
            else if (width > 500) setVisibleCols(defaultColumns - 7 > 0 ? defaultColumns - 7 : 1);

            else setVisibleCols(1);
        };

        handleResize(); // Ajusta las columnas al tamaño de la pantalla
        window.addEventListener('resize', handleResize); // Escucha el evento de redimensionar
        return () => window.removeEventListener('resize', handleResize); // Limpia el evento al desmontar el componente
    }, []);

    return { visibleCols }
};

